/* Shared garment material renderer. Kept byte-identical in theme and API. */
(function(root,factory){if(typeof module==='object'&&module.exports)module.exports=factory();else root.ClassicRenderer=factory()})(typeof globalThis!=='undefined'?globalThis:this,function(){
  'use strict'
  const size=1080, area={x:378,y:334,width:324,height:432,padding:8}
  const aliases={navy:'navy blue',green:'olive green',mustard:'mustard yellow',grey:'grey melange',gray:'grey melange'}
  function key(name){const k=String(name||'').toLowerCase().replace(/-/g,' ').trim();return aliases[k]||k}
  function find(palette,name){return palette.find(c=>key(c.name)===key(name))}
  function placement(width,height,t,printArea){
    const zone=printArea||area
    t=t||{};const scale=Math.max(.1,Math.min(1,Number(t.scale)||1)),ratio=size/(Number(t.containerWidth)||size)
    const fit=Math.min((zone.width-2*zone.padding)/width,(zone.height-2*zone.padding)/height)*scale
    const w=width*fit,h=height*fit
    const x=zone.x+(zone.width-w)/2+(Number(t.translateX)||0)*ratio
    const y=zone.y+(zone.height-h)/2+(Number(t.translateY)||0)*ratio
    return {x,y,width:w,height:h,transform:{scale,containerWidth:size/ratio,translateX:(x-zone.x-(zone.width-w)/2)/ratio,translateY:(y-zone.y-(zone.height-h)/2)/ratio}}
  }
  function sample(image,x,y){
    if(x<0||y<0||x>image.width-1||y>image.height-1)return [0,0,0,0]
    const ix=Math.floor(x),iy=Math.floor(y),fx=x-ix,fy=y-iy,r=[0,0,0,0]
    for(let j=0;j<2;j++)for(let k=0;k<2;k++){const p=(Math.min(image.height-1,iy+j)*image.width+Math.min(image.width-1,ix+k))*4,w=(k?fx:1-fx)*(j?fy:1-fy),a=image.data[p+3]/255*w;r[3]+=a;for(let c=0;c<3;c++)r[c]+=image.data[p+c]*a}
    if(r[3])for(let c=0;c<3;c++)r[c]/=r[3];return r
  }
  function prepare(source,mask,displacement){
    const luma=new Float32Array(size*size),smooth=new Float32Array(size*size)
    for(let p=0;p<luma.length;p++){const i=p*4;luma[p]=source.data[i]*.2126+source.data[i+1]*.7152+source.data[i+2]*.0722;smooth[p]=displacement.data[i]}
    return {source:source.data,mask:mask.data,luma,smooth}
  }
  function render(material,design,colour,transform,options){
    options=options||{};const out=new Uint8ClampedArray(material.source),target=colour.target,reference=colour.source,rgb=target.rgb
    const centre=rgb[0]*.2126+rgb[1]*.7152+rgb[2]*.0722,zone=options.area||area,box=placement(design.width,design.height,transform,zone)
    for(let y=0;y<size;y++)for(let x=0;x<size;x++){
      const p=y*size+x,i=p*4,m=material.mask[i+3]/255;if(!m)continue
      const value=material.luma[p],below=Math.max(0,(reference.mid-value)/(reference.mid-reference.low)),above=Math.max(0,(value-reference.mid)/(reference.high-reference.mid))
      const shadow=Math.min(.98,below*(centre-target.low)/Math.max(1,centre))*m*(options.shadow===undefined?1:options.shadow)
      const light=Math.min(.95,above*(target.high-centre)/Math.max(1,255-centre))*m*(options.light===undefined?1:options.light)
      let ink=[0,0,0,0]
      if(x>=zone.x&&x<zone.x+zone.width&&y>=zone.y&&y<zone.y+zone.height){
        const warp=options.warp===undefined?1:options.warp
        const dx=(material.smooth[p+5]-material.smooth[p-5])*.56*warp,dy=(material.smooth[p+5*size]-material.smooth[p-5*size])*.28*warp
        ink=sample(design,(x+dx-box.x+.5)*design.width/box.width-.5,(y+dy-box.y+.5)*design.height/box.height-.5)
      }
      const alpha=ink[3]*m*(options.opacity===undefined?1:options.opacity)
      for(let c=0;c<3;c++){const base=out[i+c]*(1-m)+rgb[c]*m,v=base*(1-alpha)+ink[c]*alpha;out[i+c]=v*(1-shadow)*(1-light)+255*light}
    }
    return {data:out,width:size,height:size,transform:box.transform}
  }
  function warpArtwork(material,art,zone,strength){
    const out=new Uint8ClampedArray(size*size*4);
    for(let y=Math.ceil(zone.y);y<Math.floor(zone.y+zone.height);y++)for(let x=Math.ceil(zone.x);x<Math.floor(zone.x+zone.width);x++){
      const p=y*size+x,i=p*4;if(!material.mask[i+3])continue;
      const dx=(material.smooth[p+5]-material.smooth[p-5])*.56*strength,dy=(material.smooth[p+5*size]-material.smooth[p-5*size])*.28*strength;
      const ink=sample(art,Math.max(0,Math.min(size-2,x+dx)),Math.max(0,Math.min(size-2,y+dy)));
      out[i+3]=ink[3]*material.mask[i+3];for(let k=0;k<3;k++)out[i+k]=ink[k];
    }
    return out;
  }
  return {size,area,key,find,placement,prepare,render,warpArtwork}
})
